import Component from "../classes/Component"

import { app, menu } from '../utils/store'

export class Navigation extends Component {
    constructor(){
        super({
            element: '[data-navigation]',
            elements: {
                toggler: '[data-menu-toggler]',
                about: '.mobile-menu  [href="#scroll-chi_siamo"]',
                service: '.mobile-menu  [href="#scroll-services"]',
                contact: '.mobile-menu [href="#scroll-contact"]',
                menu_mobile: '.mobile-menu',
            }
        })
            this.clickBtnMobile();
    }
    
    create(){
        super.create()
        
        app.nav = this.element
        app.root.style.setProperty('--header-height', `${app.nav.clientHeight}px`)

        if(this.elements.toggler){
            this.elements.toggler.onclick = (event) => this.onClick()
        }
    }
    
    addEventListeners(){
        window.addEventListener('resize', () => app.root.style.setProperty('--header-height', `${app.nav.clientHeight}px`))
        window.addEventListener('scroll', () => this.onScroll())
    }

    onClick = (entry) => {
        app.root.classList.toggle('navigation--open')
        
        if(menu.isOpen){
            app.html.classList.toggle('scroll--off')
            menu.isOpen = false
        } else {
            app.html.classList.toggle('scroll--off')
            menu.isOpen = true
        }
    }

    onScroll = () => {
        if(window.scrollY > app.nav.clientHeight){
            this.element.classList.add('navigation--active')
        } else {
            this.element.classList.remove('navigation--active')
        }
    }

    clickBtnMobile = () => {
        this.elements.about.addEventListener('click', (e) => {
            e.preventDefault();
            app.root.classList.remove('navigation--open')
            this.elements.menu_mobile.classList.remove('open')
        })
        this.elements.service.addEventListener('click', (e) => {
            e.preventDefault();
            app.root.classList.remove('navigation--open')
            this.elements.menu_mobile.classList.remove('open')
        })
        this.elements.contact.addEventListener('click', (e) => {
            e.preventDefault();
            app.root.classList.remove('navigation--open')
            this.elements.menu_mobile.classList.remove('open')
        })
    }

    destroy = () => { /** Code your own */ }
}

export class Footer extends Component {
    constructor(){
        super({
            element: '[data-footer]',
        })
    }
    
    create(){
        super.create()
        
        app.footer = this.element
        app.root.style.setProperty('--footer-height', `${app.footer.clientHeight}px`)
    }
    
    addEventListeners(){
        window.addEventListener('resize', () => app.root.style.setProperty('--footer-height', `${app.footer.clientHeight}px`))
    }

    destroy = () => { /** Code your own */ }
}